import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-add-org-types-modal',
  templateUrl: './add-org-types-modal.component.html',
  styleUrls: ['./add-org-types-modal.component.scss']
})
export class AddOrgTypesModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() user: User;
  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({});
  }

  onClose() {
    this.closed.emit();
  }
}
